module.exports = __webpack_public_path__ + "static/img/whatisnew-flow-1-4-4.c2f61f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whatisnew/whatisnew-flow-1-4-4.png
// module id = Fpjf
// module chunks = 4